import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../../../toolkit/uicomponent';
import { RepeatCardComponentProps } from './repeatcardcomponent';
import { RepeatCardCSSStyle } from './repeatcardcss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export class RepeatCardViewImpl extends UIComponentViewImpl<UIDataModel>
{
  
    draw(props: RepeatCardComponentProps, state: UIComponentState, cssStyle: RepeatCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={props.cssStyle.getWrapperCSSStyle()}>
               <label style={props.cssStyle.getLabelCSSStyle(props.isSelected)}>
                   
                   
                    {this.getFrenchRepeatDayTitle(props.title)}
               </label>
            </div>
        );
    }

    
    getFrenchRepeatDayTitle(title:string):string{
        if(title === this.getContext().getResources().getString(Strings.mon))
        {
            return this.getContext().getResources().getString(Strings.mon_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.tue))
        {
            return this.getContext().getResources().getString(Strings.tue_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.wed))
        {
            return this.getContext().getResources().getString(Strings.wed_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.thu))
        {
            return this.getContext().getResources().getString(Strings.thu_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.fri))
        {
            return this.getContext().getResources().getString(Strings.fri_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.sat))
        {
            return this.getContext().getResources().getString(Strings.sat_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.sun))
        {
            return this.getContext().getResources().getString(Strings.sun_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.none))
        {
            return this.getContext().getResources().getString(Strings.none_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.monthly))
        {
            return this.getContext().getResources().getString(Strings.monthly_title);
        }
        else  if(title === this.getContext().getResources().getString(Strings.yearly))
        {
            return this.getContext().getResources().getString(Strings.yearly_title);
        }
        else
        {
            return "";
        }
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/repeatcard/repeatcardview.tsx